import React from 'react';
import dayjs from 'dayjs';
import { Popconfirm, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import styles from './DeviceTypes.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const commonColumns = (t, detailDeviceType) => [
  {
    title: t('tables.devices_type.columns.name'),
    width: '17%',
    dataIndex: 'name',
    fixed: 'left',
    sorter: true,
  },
  {
    width: '16%',
    title: t('forms.users.labels.business_line'),
    dataIndex: 'business_type_name',
    render: (business_type_name) => business_type_name || '',
  },
  {
    width: '16%',
    title: t('tables.devices_type.columns.description'),
    dataIndex: 'description',
    render: (description) => description || '',
  },
  {
    width: '16%',
    title: t('tables.devices_type.columns.modbus_map'),
    dataIndex: 'modbus_map_name',
    render: (modbus_map_name) => modbus_map_name || '',
  },
  {
    width: '16%',
    title: t('tables.devices_type.columns.fild'),
    dataIndex: 'variable_name',
    render: (variable_name) => variable_name || '',
  },
  {
    width: '16%',
    title: t('tables.devices_type.columns.devices_associated'),
    dataIndex: 'devices_name',
    render: (devices_name) => devices_name || '',
  },
];

const columnsDevicesType = (t, deleteDeviceType, editDeviceType, detailDeviceType, currentUser) => {

  const isAdmin = currentUser.role === 'Superadmin' || currentUser.role === 'Admin';

  const columns = commonColumns(t, detailDeviceType);

  if (isAdmin) {

    columns.push(
      {
        width: '10%',
        title: t('tables.common_columns.detail'),
        render: (_, record) => ( // view datails
          // eslint-disable-next-line react/jsx-filename-extension
          <div
            onClick={() => detailDeviceType(record)}
            onKeyDown={() => detailDeviceType(record)}
            role="link"
            tabIndex={0}
          >
            <span
              style={{
                color: '#828282',
                borderBottom: '1px solid #828282',
                cursor: 'pointer',
              }}
            >
              {t('tables.users.columns.view')}
            </span>
          </div>
        ),
      },
      {
        key: 'has_missing_data_alarm_rule',
        width: '20%',
        title: '',
        dataIndex: 'id',
        render: (_, record) => ( // edit users
          // eslint-disable-next-line react/jsx-filename-extension
          <Space>
            <div className={styles.btnsIcon} style={{ marginRight: 5 }}>
              <FontAwesomeIcon icon={faEdit} onClick={() => editDeviceType(record)} />
            </div>

            <div className={styles.btnsIcon} style={{ marginLeft: 5 }}>
              <Popconfirm
                title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
                okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
                cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
                onConfirm={() => deleteDeviceType(record)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Popconfirm>
            </div>
          </Space>
        ),
      },

    );

}

  return columns;

};

export default columnsDevicesType;
